import replace from 'lodash/fp/replace';
import { string } from 'prop-types';
import { DeprecatedCreatePhoneNumber as CreatePhoneNumber } from '@aon-coverwallet/cw-react-components';
import { StyledLink } from 'src/components/common/styledComponents/styledLink';
import {
  internationalization,
  phoneNumberPattern,
  phoneMaxLength,
  phoneMinLength,
} from 'src/utils/capabilities';

const phoneNumberObject = CreatePhoneNumber(
  internationalization.phoneCountry || 'US',
);

const { formattedPhone } = phoneNumberObject;

/*
  TO-DO: PhoneLink component exists in cw-react-components.
  Here is customised until the library implemented hiding prefix
  for URINumbers according to capabilities.
*/

const PhoneLink = ({ phone }) => {
  return (
    <StyledLink href={builtURINumber(phone)}>
      {formattedPhone(phone).nationalNumber}
    </StyledLink>
  );
};

PhoneLink.propTypes = {
  phone: string,
};

const getDigits = replace(/\D/g, '');

const isPhone = (phone = '') => {
  const regex = new RegExp(phoneNumberPattern);
  const phoneDigits = getDigits(phone);
  const isSizeCorrect =
    phoneDigits.length >= phoneMinLength &&
    phoneDigits.length <= phoneMaxLength;
  return regex.test(phone) && isSizeCorrect;
};

const builtURINumber = phone => {
  if (internationalization.hideHeaderAgentPhone) {
    return '#';
  } else if (internationalization.hidePhoneCountryPrefix) {
    return `tel:${formattedPhone(phone).nationalNumber}`;
  } else return formattedPhone(phone).URINumber;
};

const getFormattedPhone = phone => {
  const formattedPhoneObject = formattedPhone(phone);
  return {
    URINumber: builtURINumber(phone),
    internationalNumber: formattedPhoneObject.internationalNumber,
    isValid: formattedPhoneObject.isValid,
    nationalNumber: formattedPhoneObject.nationalNumber,
  };
};

const PhoneHelper = {
  getRawPhone: getDigits,
  isPhone,
  getFormattedPhone,
  getPhoneLink: PhoneLink,
};

export { PhoneHelper };
